// Pickup Station - Customer pickup management
import React from 'react';
import { Package } from 'lucide-react';
import BaseStationScreen from '../components/BaseStationScreen';

const PickupStation: React.FC = () => {
  return (
    <BaseStationScreen
      stationId="pickup"
      stationName="Ready for Pickup"
      stationIcon={<Package className="w-6 h-6" />}
      stationColor="#06B6D4"
      showAdvanceButton={true} // Enable advance button for "Mark as Completed"
      showCustomerContact={true} // Show contact info for customer notification
      showDeliveryInfo={false}
    />
  );
};

export default PickupStation;
